import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { devLog } from 'src/app/core/utils/generic-utils';
import { dateFormatOptions } from '../../constants/constants';

@Component({
  selector: 'app-customer-training',
  templateUrl: './customer-training.component.html',
  styleUrls: ['./customer-training.component.scss'],
  standalone: false,
})
export class CustomerTrainingComponent implements OnInit {
  files: { name: string; url: string; lastModified: string }[] = [];

  readonly columns: string[] = ['title', 'date', 'url'];

  // store basepath
  readonly basePath: string = window.location.origin;

  // Flag to handle the spinner
  spinner: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<CustomerTrainingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CustomerTrainingData,
  ) {}

  ngOnInit(): void {
    this.files = this.data.files;
  }

  formatName(rawName: string): string {
    return rawName
      .replace(/^.*[\\\/]/, '')
      .replace(/\.[^/.]+$/, '')
      .replaceAll('_', ' ');
  }

  formatDate(date: string): string {
    const dateParsed = new Date(date);
    return dateParsed.toLocaleDateString('en-US', dateFormatOptions);
  }

  close() {
    this.dialogRef.close();
  }
}
interface CustomerTrainingData {
  files: { name: string; url: string; lastModified: string }[];
}
